import script from "./IpSearchWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./IpSearchWidget.vue?vue&type=script&setup=true&lang=js"

import "./IpSearchWidget.vue?vue&type=style&index=0&id=a0126760&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0126760"]])

export default __exports__